const LeftArrow = ({ ...props }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.6666 21.3332L9.33325 15.9998M9.33325 15.9998L14.6666 10.6665M9.33325 15.9998H23.1054"
        stroke="#090914"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LeftArrow;
